import { useState } from 'react';

import { downloadFile } from 'lib/networking/http';
import SwalDialog from 'lib/utils/toast';

// Shared file-export helper for the download-an-xlsx buttons: tracks an `exporting` flag and
// streams `url` to a browser download, surfacing `errorMessage` via a toast on failure.
// A falsy `url` makes `onExport` a no-op (e.g. before a required id is known).
// Returns { exporting, onExport }.
function useFileExport(url, fallbackName, errorMessage) {
  const [exporting, setExporting] = useState(false);

  const onExport = () => {
    if (!url) return;
    setExporting(true);
    downloadFile(url, fallbackName)
      .catch(() => SwalDialog('error', errorMessage, 'Export failed'))
      .finally(() => setExporting(false));
  };

  return { exporting, onExport };
}

export default useFileExport;
